/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchInput/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function SearchInput({
  children,
  viewPath = "/App/Account/Topbar/SearchInput",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  let isMedia = useIsMedia()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<fromFlow.When is={!isMedia.mobile}>
<button
  data-testid="SearchInput.Horizontal"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onClick={() => setFlowTo("/App/Account/Search/Content")}
 {...isHoveredBind}
 style={{'--bc-2-1j26lh': dtColorsNeutral600,'--bc-1-1j26lh': hovered ? dtColorsNeutral700 : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconSearch
  viewPath={`${viewPath}/TysiaIconSearch`}
 width={16}
 height={16}
 fill={dtColorsNeutral100}
/>
<fromFlow.When is={!isMedia.mobile}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={8}
 weight="semibold"
 size="large"
 text="Search..."
 color={dtColorsNeutral100}
/>
</fromFlow.When>
</button>
</fromFlow.When>
<fromFlow.When is={isMedia.mobile}>
<button
  data-testid="SearchInput.Horizontal:1"
  data-view-path={viewPath}
 onClick={() => setFlowTo("/App/Account/Search/Content")}
 {...isHoveredBind}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-1j26lh': hovered && selected ? dtColorsNeutral700 : hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSearch
  viewPath={`${viewPath}/TysiaIconSearch`}
 width={16}
 height={16}
 fill={dtColorsNeutral100}
/>
</button>
</fromFlow.When>
{children}
</React.Fragment>)
}